'use client';

import { LegalNavDock } from 'Workadabra/shared/nav-dock/legal-dock';
import { WorkadabraNavDock } from 'Workadabra/shared/nav-dock/main-dock';
import { usePathname } from 'next/navigation';

const LEGAL_PATH_SUFFIXES = ['/privacy-policy', '/terms-of-service', '/cookie-policy', '/gdpr'];

export const ContextualNavDock = () => {
  const pathname = usePathname() ?? '';
  const isLegal = LEGAL_PATH_SUFFIXES.some(suffix => pathname.endsWith(suffix) || pathname.includes(`${suffix}/`));
  return isLegal ? <LegalNavDock /> : <WorkadabraNavDock />;
};
